import { wrapCreateBrowserRouter } from '@sentry/react';
import { createBrowserRouter, Navigate, useLocation, useParams } from 'react-router-dom';

import AddressResult from './address-result/AddressResult';
import CheckpointDetail from './checkpoints/CheckpointDetail';
import EpochDetail from './epochs/EpochDetail';
import Home from './home/Home';
import { ObjectResult } from './object-result/ObjectResult';
import { Recent } from './recent';
import TransactionResult from './transaction-result/TransactionResult';
import { ValidatorDetails } from './validator/ValidatorDetails';
import { ValidatorPageResult } from './validators/Validators';
import { Layout } from '~/components/Layout';

function RedirectWithId({ base }: { base: string }) {
	const params = useParams();
	const { search } = useLocation();
	return <Navigate to={`/${base}/${params.id}${search}`} replace />;
}

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
	{
		path: '/',
		element: <Layout />,
		children: [
			// 1 已完成
			{ path: '/', element: <Home /> },
			// 2 已完成
			{ path: 'recent', element: <Recent /> },
			// 完成 3
			{ path: 'object/:id', element: <ObjectResult /> },
			// 4 已完成
			{ path: 'checkpoint/:id', element: <CheckpointDetail /> },
			// 5  未显示 过 (剩余 这页面)
			{ path: 'epoch/current', element: <EpochDetail /> },
			// 6 已完成
			{ path: 'txblock/:id', element: <TransactionResult /> },
			//  已完成
			{ path: 'epoch/:id', element: <EpochDetail /> },
			// 7 开始 14：52  (剩余 这页面)
			{ path: 'address/:id', element: <AddressResult /> },
			// 8 已完成  第二次完成
			{ path: 'validators', element: <ValidatorPageResult /> },
			//  9 完成 已完成   第二次完成
			{ path: 'validator/:id', element: <ValidatorDetails /> },
		],
	},
	{
		path: '/transactions',
		element: <Navigate to="/recent" replace />,
	},
	// Support legacy routes:
	{
		path: '/objects/:id',
		element: <RedirectWithId base="object" />,
	},
	{
		path: '/transaction/:id',
		element: <RedirectWithId base="txblock" />,
	},
	{
		path: '/transactions/:id',
		element: <RedirectWithId base="txblock" />,
	},
	{
		path: '/addresses/:id',
		element: <RedirectWithId base="address" />,
	},
	// 404 route:
	{ path: '*', element: <Navigate to="/" replace /> },
]);
